import { useState } from 'react';

const API = process.env.REACT_APP_API_URL;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setMsg('');
    try {
      await fetch(`${API}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ email: email.trim() })
      });
      setMsg('Hvis e-posten finnes, er instruks sendt.');
    } catch {
      setMsg('Hvis e-posten finnes, er instruks sendt.');
    }
  }

  return (
    <div className="max-w-md mx-auto mt-20 bg-white p-8 rounded-lg shadow">
      <h1 className="text-2xl font-bold text-[#000099] mb-4">Glemt passord</h1>
      <form onSubmit={handleSubmit} className="space-y-3">
        <input
          type="email"
          placeholder="Din e-post"
          value={email}
          onChange={e=>setEmail(e.target.value)}
          required
          className="w-full border rounded px-3 py-2"
        />
        <button className="w-full bg-[#000099] text-white font-semibold py-2 px-4 rounded">
          Send lenke
        </button>
      </form>
      {msg && <p className="mt-3 text-sm">{msg}</p>}
    </div>
  );
}
